import { Component } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-unauthorized-error',
  templateUrl: './unauthorized-error.component.html',
  styleUrls: ['./unauthorized-error.component.scss'],
})
export class UnauthorizedErrorComponent {
  constructor(private titleService: Title, private metaService: Meta) {
    this.titleService.setTitle('Contact Us - Error');
    this.metaService.updateTag({ name: 'robots', content: 'noindex' });
  }
}
